import { css } from 'lit';

// A person as a light pill row on a light grey panel: an initials avatar, then cells of a bold value
// over a grey caption, then round action buttons. Used by the "Who do you report to?" and "Verify the
// below" job cards. Each card sets the row's grid-template-columns for the cells it has.
export const nsPersonRowStyles = css`
  .person-row {
    display: grid;
    align-items: center;
    gap: var(--wa-space-s);

    background: var(--ns-theme-container);
    color: var(--ns-theme-black);

    padding: var(--wa-space-2xs) var(--wa-space-s);
    border-radius: var(--wa-border-radius-pill);
  }

  .person-row + .person-row {
    margin-top: var(--wa-space-xs);
  }

  .person-row__avatar {
    width: 32px;
    height: 32px;

    border-radius: var(--wa-border-radius-circle);
    overflow: hidden;

    background: var(--primary-button-background-color);
    color: var(--ns-theme-white);
    font-size: var(--wa-font-size-2xs);
    font-weight: 700;
  }

  .person-row__avatar img {
    width: auto;
    height: 100%;
    padding: var(--wa-space-3xs) var(--wa-space-xs);
    aspect-ratio: 1 / 1;
  }

  .person-row__cell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    font-size: var(--wa-font-size-s);
  }
  .person-row .value {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .person-row .caption {
    display: flex;
    align-items: center;
    gap: var(--wa-space-2xs);
    color: var(--ns-theme-type);
    font-size: var(--wa-font-size-2xs);
  }
  .person-row .caption-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* A short status next to the caption, such as "Primary" or "Verified" */
  .status-badge {
    flex: none;
    padding: 0 var(--wa-space-2xs);
    border-radius: var(--wa-border-radius-pill);
    background: var(--ns-theme-green);
    color: var(--ns-theme-black);
    font-size: var(--wa-font-size-3xs);
    font-weight: 700;
    text-transform: uppercase;
  }

  .person-row__action {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;

    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0;

    background: var(--ns-theme-type);
    color: var(--ns-theme-white);
    border: 0;
    border-radius: var(--wa-border-radius-circle);
    cursor: pointer;
  }
  .person-row__action:hover,
  .person-row__action:focus-visible {
    background: var(--ns-theme-type);
  }
  .person-row__action:focus-visible {
    outline: 2px solid var(--ns-theme-purple);
    outline-offset: 2px;
  }
  .person-row__action ns-icon {
    width: 10px;
    height: 10px;
  }
`;
